export default "__VITE_ASSET__CdsM6Nr$__"